export const EXPERIENCE_OPTION_LOADING = "EXPERIENCE_OPTION_LOADING";
export const EXPERIENCE_OPTION_SUCCESS = "EXPERIENCE_OPTION_SUCCESS";
export const EXPERIENCE_OPTION_FAILED = "EXPERIENCE_OPTION_FAILED";

export const EMPLOYMENT_DOCUMENT_LOADING = "EMPLOYMENT_DOCUMENT_LOADING";
export const EMPLOYMENT_DOCUMENT_SUCCESS = "EMPLOYMENT_DOCUMENT_SUCCESS";
export const EMPLOYMENT_DOCUMENT_FAILED = "EMPLOYMENT_DOCUMENT_FAILED";




